//social
import telegram from '../assets/img/social/telegram.png';
import discord from '../assets/img/social/discord.png';
import youtube from '../assets/img/social/youtube.png';
import twitter from '../assets/img/social/twitter.png';
import reddit from '../assets/img/social/twitter.png';
import tiktok from '../assets/img/social/twitter.png';
import instagram from '../assets/img/social/instagram.png';
import x from '../assets/icons/shapes/x.png';
//end social

//system
import support from '../assets/icons/support.png';
import faq from '../assets/icons/faq.png';
import share from '../assets/icons/share.png';
import dog from '../assets/img/dog.png';
import promo_share from '../assets/icons/promo_share.png';
import setting from '../assets/icons/setting.png';
import checked from '../assets/icons/checked.png';
import gift from '../assets/icons/Gift.png';
import octo from '../assets/logo/logo.png';
import inc from '../assets/icons/in.png';
import wallet from '../assets/icons/wallet.png';
import friend from '../assets/icons/friend.png';
import dep from '../assets/icons/balance/deopsit.png';
import withdraw from '../assets/icons/balance/withdraw.png';
import history from '../assets/icons/balance/history.png';
import def from '../assets/img/def.png';
import cup from '../assets/icons/cup.png';
import img from '../assets/icons/picture_placeholder.png';
//end system

//shapes
import crown from '../assets/icons/shapes/crown.png';
import diamond from '../assets/icons/shapes/diamond.png';
import plus from '../assets/icons/shapes/plus.png';
import Star from '../assets/icons/shapes/thin_star.png';
import Star_big from '../assets/icons/shapes/star.png';
import Rectangle from '../assets/icons/shapes/square.png';
import polygon from '../assets/icons/shapes/polygon.png';
import tg_star from '../assets/icons/blockchains/tg_star.png';
//end shapes

//shapes-outlined
import ou_polygon from '../assets/icons/out_shapes/polygone_out.png';
import ou_rectangle from '../assets/icons/out_shapes/rectangle_out.png';
import out_star from '../assets/icons/out_shapes/star_out.png';
import ou_plus from '../assets/icons/out_shapes/plus_out.png';
import ou_crown from '../assets/icons/out_shapes/crown_out.png';
import out_small_star from '../assets/icons/out_shapes/thin_star_out.png';
import ou_diamond from '../assets/icons/out_shapes/diamond_out.png';
//end shapes-outlined

//chains
import solana from '../assets/icons/blockchains/solana.png';
import BNB from '../assets/icons/blockchains/BNB.png';
import ETH from '../assets/icons/blockchains/ETH.png';
import TON from '../assets/icons/blockchains/TON.png';
import USDC from '../assets/icons/blockchains/USDC.png';
import USDT from '../assets/icons/blockchains/USDT.png';
//end chains
//tasks
import youtube_bell from '../assets/img/tasks/youtube_bell.png'
import youtube_video from '../assets/img/tasks/youtube_video.png'
import youtube_sub from '../assets/img/tasks/youtube_sub.png'
import custom from '../assets/icons/custom.png'
//end tasks

const icons = [
    //social
    {name: "telegram", icon: telegram},
    {name: "instagram", icon: instagram},
    {name: "reddit", icon: reddit},
    {name: "discord", icon: discord},
    {name: "youtube", icon: youtube},
    {name: "tiktok", icon: tiktok},
    {name: "twitter", icon: twitter},
    {name: "support", icon: support},
    //end social

    //system
    {name: "faq", icon: faq},
    {name: "share", icon: share},
    {name: "promo_share", icon: promo_share},
    {name: "dog", icon: dog},
    {name: "setting", icon: setting},
    {name: "checked", icon: checked},
    {name: "gift", icon: gift},
    {name: "octo", icon: octo},
    {name: "inc", icon: inc},
    {name: "wallet", icon: wallet},
    {name: "friend", icon: friend},
    {name: "def", icon: def},
    {name: "dep", icon: dep},
    {name: "withdraw", icon: withdraw},
    {name: "history", icon: history},
    {name: "cup", icon: cup},
    {name: "img", icon: img},
    //end system

    //shapes
    {name: "crown", icon: crown},
    {name: "plus", icon: plus},
    {name: "x", icon: x},
    {name: "diamond", icon: diamond},
    {name: "star", icon: Star},
    {name: "star_big", icon: Star_big},
    {name: "rectangle", icon: Rectangle},
    {name: "polygon", icon: polygon},
    {name: "tg_star", icon: tg_star},
    //end shapes

    //shapes-outlined
    {name: "ou_polygon", icon: ou_polygon},
    {name: "ou_rectangle", icon: ou_rectangle},
    {name: "out_star", icon: out_star},
    {name: "ou_plus", icon: ou_plus},
    {name: "ou_crown", icon: ou_crown},
    {name: "out_small_star", icon: out_small_star},
    {name: "ou_diamond", icon: ou_diamond},
    //end shapes-outlined

    //chains
    {name: "solana", icon: solana},
    {name: "BNB", icon: BNB},
    {name: "TON", icon: TON},
    {name: "USDC", icon: USDC},
    {name: "USDT", icon: USDT},
    {name: "ETH", icon: ETH},
    //end chains
    //tasks
    {name:"youtube bell",icon:youtube_bell},
    {name:"youtube sub",icon:youtube_sub},
    {name:"youtube video",icon:youtube_video},
    {name:"custom",icon:custom},
    //end tasks
]

const getIcon = (name) => {
    const icon = icons.find((item) => item.name === name);
    return icon ? icon.icon : null; // Возвращаем иконку или null, если иконка не найдена
};

export default getIcon;
